import { Badge, BadgeVariant } from "../Badge";

import { getTrialDaysRemaining } from "@/components/PlanCard/utils";
import { useOrganizationSubscriptionData } from "@/providers";

export const TrialPill = () => {
  const { trialEndsAt, currentPeriodEnd, isTrialPlan } = useOrganizationSubscriptionData();

  const endDate = isTrialPlan && trialEndsAt ? trialEndsAt : currentPeriodEnd;
  const daysRemaining = getTrialDaysRemaining(endDate!);

  if (!daysRemaining) {
    return null;
  }

  const getText = () => {
    if (daysRemaining.value <= 0) {
      return "Trial has ended";
    }
    if (daysRemaining.value === 1) {
      return "Trial ends in 1 day";
    }
    return `Trial ends in ${daysRemaining.value} days`;
  };
  const text = getText();

  return <Badge variant={BadgeVariant.AMBER} text={text} />;
};
